module.exports = __webpack_public_path__ + "img/serveContent1.10400c70.png";